module.exports = __webpack_public_path__ + "img/step-5.5faf5ccd.png";